<template>
  <transition name="Instructions">
    <div class="Instructions">
      <div class="Instructions__container">
        <div class="Instructions__col is-left">
          {{ trans('left') }}
          <div class="Btn" @click="next">
            {{ trans('btn') }}
          </div>
        </div>
        <div class="Instructions__col is-right" v-for="(text, index) in trans('right')"  :class="['is-' + index]">
          <div class="Instructions__block">
            <div v-html="text"></div>
            <img v-if="index == 0" class="Instructions__cursor-direction" :src="require('./img/mouvement-curseur.gif')" />
            <img v-if="index == 1" class="Instructions__cursor-actif" :src="require('./img/curseur-actif-frames.gif')" />

            <div class="Instructions__key" v-if="index == 2">
              <template v-if="!$root.$agent.mobile">
                <img v-lazy="require('./img/arrow.png')" />
                <span>{{ trans('or') }}</span>
                <img v-lazy="require('./img/letter.png')" />
              </template>
              <img v-else v-lazy="require('./img/btn-tablet.png')" />
            </div>

            <div class="Instructions__btn" v-if="index == 3">
              <template v-if="!$root.$agent.mobile">
                <div class="Instructions__btn-space">{{ trans('space') }}</div>
                <span>{{ trans('or') }}</span>
              </template>
              <img v-lazy="require('./img/btn.png')" class="Instructions__btn-btn" />
            </div>

          </div>
        </div>

      </div>

    </div>
  </transition>
</template>

<script>
export default {
  name: 'Instruction',
  translations: {
    fr: {
      or: 'ou',
      space: 'espace',
      left: `Avant de commencer, lisez ces quelques points. Cela améliorera votre expérience.`,
      right: [
        `Cette expérience se situe dans un monde en 3D. L’image que vous voyez à l’écran se déplace dans la même direction que votre curseur.`,
        `Le curseur vous indiquera lorsqu’un élément est interactif.`,
        `Utilisez les flèches ou les touches W, A, S, D de votre clavier pour explorer le monde mystérieux de la galerie.`,
        `Pour continuer, cliquez sur le bouton ESPACE ou sur la flèche ci-dessous.`,
      ],
      tablet: [
        `Utilisez les flèches pour explorer le monde mystérieux de La Galerie des mystères.`,
        `Pour continuer, cliquez sur sur la flèche ci-dessous.`,
      ],
      btn: 'Jouer avec Enki',
    },
    en: {
      or: 'or',
      space: 'space',
      left: `Before starting, read these few points. It will improve your experience.`,
      right: [
        `This experience takes place in a 3D world. The image that you see on the screen moves in the same direction as your cursor.`,
        `The cursor will indicate when an element is interactive.`,
        `Use the arrows or the W, A, S, and D keys on your keyboard to explore the mysterious world of the gallery.`,
        `To continue, click on the SPACE button or on the arrow below.`,
      ],
      tablet: [
        `Use the arrows to explore the mysterious world of The Gallery of Mysteries.`,
        `To continue, click on the arrow below.`,
      ],
      btn: 'Play with Enki',
    }
  },
  created() {
    if(this.$root.$agent.mobile) {
      this.$options.translations[this.lang].right[2] = this.$options.translations[this.lang].tablet[0]
      this.$options.translations[this.lang].right[3] = this.$options.translations[this.lang].tablet[1]
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Instructions
  position fixed
  top 0px
  left 0px
  height 100vh
  width 100vw
  background rgba(#0a0a0a, 1)
  transition opacity 1s
  &-enter
  &-leave-active
    opacity 0

  &__container
    lost-utility clearfix
    width 1200px
    margin 0 auto
    top 50%
    left 50%
    position fixed
    transform translate(-50%, -50%)
    max-width 100%

  &__cursor-direction
    max-width 290px
    +max-screen(tablet)
      max-width 200px
      margin-top 10px
  &__cursor-actif
    max-width 160px
    +max-screen(tablet)
      max-width 130px

  &__col
    padding 40px
    &.is-left
      font-size 18px
      line-height 24px
      padding-right 100px
      lost-column 4/12 3
      +max-screen(tablet)
        padding-right 50px
      .Btn
        width 260px
    &.is-right
      font-size 15px
      line-height 20px
    &.is-0
    &.is-2
      lost-column 4.5/12 3
    &.is-1
    &.is-3
      lost-column 3.5/12 3
    &.is-2
      lost-offset 4/12

  img
    display block

  &__key
    margin-top 40px
    height 100px
    +max-screen(tablet)
      margin-top 50px
    img
    span
      display inline-block
    img
      width 120px
      +max-screen(tablet)
        width 120px
    span
      position relative
      margin 0 30px
      top -40px

  &__btn
    span
      display block
      margin 10px 0
    &-space
      margin-top 20px
      border 1px solid rgba(white, .3)
      padding 8px 0 6px
      text-align center
      text-transform uppercase
      font-size 12px
      letter-spacing .2em
      font-weight 700
    &-btn
      width 60px
      +max-screen(tablet)
        margin-top 80px

  &__block
    position relative
    height 220px
    font-size 18px
    line-height 24px

    +max-screen(tablet)
      height 170px
      font-size 15px
      line-height 19px

    &:before
      position absolute
      left -40px
      top 0px
      content ''
      width 1px
      background linear-gradient(to bottom, rgba(blue, 1), rgba(yellow, 1))
      height 100%

  .Btn
    position relative
    margin-top 40px
    bottom auto
    right auto
    display inline-block
    background linear-gradient(to right, rgba(blue, 1), rgba(yellow, 1))
    color white
</style>



// WEBPACK FOOTER //
// src/components/instructions/Instructions.vue